import { useState, useEffect, ChangeEvent, useCallback } from 'react';
import { useUnmount } from 'react-use';

import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { IKnoOrganisationFunction } from 'APIPackage/AccountModule/interfaces/IKnoOrganisationFunction';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';

import styles from './FunctionsModal.module.scss';

interface IFunctionsModalProps {
  visible?: boolean;
  id?: string;
  functionsList?: Array<IKnoOrganisationFunction>;
  onApply: (knoId: string, functionId?: number) => void;
  onClose: () => void;
}

export const FunctionsModal = ({ visible, id, functionsList, onApply, onClose }: IFunctionsModalProps) => {
  const [currentFunctionsList, setCurrentFunctionsList] = useState<Array<IKnoOrganisationFunction>>([]);

  useEffect(() => {
    if (functionsList) {
      setCurrentFunctionsList(
        functionsList.map(item => ({
          ...item,
          fullName: `(${item.idFrgu}) ${item.fullName}`,
        })),
      );
    }
  }, [functionsList]);

  useUnmount(() => {
    setCurrentFunctionsList([]);
  });

  const handleCheckboxChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const functionId = e.target.id;

    setCurrentFunctionsList(prev =>
      prev.map(item => {
        let { byDefault: isDefault } = item;

        if (item.id.toString() === functionId) {
          isDefault = true;
        } else {
          isDefault = false;
        }

        return { ...item, byDefault: isDefault };
      }),
    );
  }, []);

  const handleApplyButtonClick = useCallback(() => {
    const checkedFunctionId = currentFunctionsList.find(item => item.byDefault)?.id;

    if (id && checkedFunctionId) {
      onApply(id, checkedFunctionId);
    }
    onClose();
  }, [currentFunctionsList, id, onApply, onClose]);

  if (!visible) {
    return null;
  }

  return (
    <Modal visible={visible} modalBodyClassName={styles.ModalBody} onClose={onClose}>
      <ModalHeader title="Выбор функции по умолчанию" sizeText="small" />
      <ModalBody size="content" border="bottom" overflow="scroll">
        {currentFunctionsList.map(item => (
          <div className={styles.Item} key={item.id}>
            <Checkbox
              id={item.id.toString()}
              name="frguFunctions"
              label={item.fullName}
              type="radio"
              theme="system"
              size="medium"
              checked={item.byDefault}
              onChange={handleCheckboxChange}
            />
          </div>
        ))}
        {currentFunctionsList.length === 0 && <div className={styles.EmptyText}>Функции не найдены</div>}
      </ModalBody>
      <ModalActions>
        <Button text="Ок" color="primary" size="medium" onClick={handleApplyButtonClick} />
        <Button text="Закрыть" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
